const tableHeaders = {
  products: [
    "اسم الصنف",
    "الكود",
    "الماركة",
    "الحجم",
    "اللون",
    "المكان",
    "بلد المنشـأ",
    "العدد",
    "السعر",
    "إجراءات",
  ],
  customers: [
    "اسم العميل",
    "كود العميل",
    "رقم الهاتف",
    "عنوان العميل",
    "إجراءات",
  ],
  vendors: [
    "اسم المورد",
    "كود المورد",
    "رقم الهاتف",
    "عنوان المورد",
    "إجراءات",
  ],
  transactions: [
    "اسم الصنف",
    "حركة الصنف",
    "الكود",
    "الماركة",
    "العدد",
    "السعر",
    "العميل",
    "التاريخ",
  ],
  submittedPermission: [
    "اسم الصنف",
    "الكود",
    "الماركة",
    "الحجم",
    "اللون",
    "العدد",
    "السعر",
    "الاجمالى",
  ],
  permission: [
    "اسم الصنف",
    "الكود",
    "الماركة",
    "الحجم",
    "اللون",
    "العدد",
    "السعر",
    "الاجمالى",
    "إجراءات",
  ],
  soldInvoices: ["اسم العميل", "التاريخ", "رقم الفاتورة", "إجراءات"],
  additionInvoices: ["اسم المورد", "التاريخ", "رقم الفاتورة", "إجراءات"],
  addInvoiceDetails: [
    "اسم الصنف",
    "الكود",
    "الماركة",
    "الحجم",
    "اللون",
    "المكان",
    "العدد",
    "السعر",
    "الاجمالي",
  ],
  soldInvoiceDetails: [
    "اسم الصنف",
    "الكود",
    "الماركة",
    "الحجم",
    "اللون",
    "العدد",
    "السعر",
    "الاجمالي",
  ],
  movements: [
    "اسم الصنف",
    "حركة الصنف",
    "الكود",
    "الماركة",
    "العدد",
    "السعر",
    "العميل",
    "التاريخ",
  ],
};

export default tableHeaders;
